import { Post } from '../types/post';

interface ExportOptions {
  quality: 'high' | 'medium' | 'low';
  format: 'mp4' | 'webm';
}

const defaultExportOptions: ExportOptions = {
  quality: 'high',
  format: 'mp4'
};

async function compileVideos(posts: Post[], options: ExportOptions = defaultExportOptions): Promise<Blob> {
  // This is a placeholder for video compilation logic
  // In a real implementation, you would:
  // 1. Download all videos
  // 2. Use WebAssembly-based video processing library or backend service
  // 3. Combine videos and return the result

  // For now, we'll simulate the process with a delay
  await new Promise(resolve => setTimeout(resolve, 2000));

  // Return a dummy blob
  return new Blob(['placeholder'], { type: 'video/mp4' });
}

export const mediaUtils = {
  hasVideo(post) {
    return post?.data?.preview?.reddit_video_preview ||
      post?.data?.preview?.images?.[0]?.variants?.mp4;
  },

  hasImage(post) {
    return post?.data?.preview?.images?.[0]?.source?.url;
  },

  hasEmbed(post) {
    return post?.data?.secure_media_embed?.content;
  },

  getImageStyle(post) {
    const image = post?.data?.preview?.images?.[0]?.source;
    if (!image?.width || !image?.height) return '';

    return `width: ${image.width}px; height: ${image.height}px; max-width: 100%;`;
  },

  getVideoStyle(post) {
    const vid = post?.data?.preview?.reddit_video_preview ||
      post?.data?.preview?.images?.[0]?.variants?.mp4;
    if (!vid?.width || !vid?.height) return '';

    return `width: ${vid.width}px; height: ${vid.height}px; max-width: 100%; `;
  },

  getVideoUrl(post) {
    let url = '';
    if (post?.data?.preview?.reddit_video_preview) {
      url = post.data.preview.reddit_video_preview.fallback_url;
    } else if (post?.data?.preview?.images?.[0]?.variants?.mp4) {
      url = post.data.preview.images[0].variants.mp4.source.url;
    }
    return this.unescapeHTML(url);
  },

  getImageUrl(post) {
    const url = this.unescapeHTML(post?.data?.preview?.images?.[0]?.source?.url || '')
    return url;
  },

  sanitizeFileName(input: string): string {
    return input
      .replace(/[^a-zA-Z0-9_\-\. ]/g, '')
      .replace(/\s/g, '_')
      .substring(0, 255);
  },

  unescapeHTML(html: string): string {
    if (!html) return '';
    const textarea = document.createElement("textarea");
    textarea.innerHTML = html;
    return textarea.value;
  },

  async handleExport() {
    try {
      this.isExporting = true;
      const compiledVideo = await compileVideos(this.clipsPosts);

      // Create a download URL
      const url = URL.createObjectURL(compiledVideo);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'compilation.mp4';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);

      // Show the export modal
      this.showExportModal = true;
    } catch (error) {
      console.error('Error exporting video:', error);
      // Handle error appropriately
    } finally {
      this.isExporting = false;
    }
  },

};
